import React from 'react'
import { colors } from '../util/tag_utils'

class SwatchPicker extends React.Component {
    constructor(props) {
        super(props)
        this.isSelected = this.isSelected.bind(this)
        this.handleSelect = this.handleSelect.bind(this)
    }

    swatchStyles(color) {
        return {
            background: color,
        }
    }

    handleSelect(color) {
        return () => this.props.setColor(color)
    }

    isSelected(color) {
        const checkmark = <span style={{fontSize: '1.6em', fontWeight: 300, color: '#fff', margin: '4% 4% 0 0'}} className="glyphicon glyphicon-ok"></span>

        return color === this.props.color ? checkmark : ''
    }

    render() {
        const { color: selectedColor } = this.props
        return (
            <div className="color-picker-container">
                <div ref={ref => this.picker = ref} className="color-picker-colors">
                    {colors.map((color, i)=> {
                        const classNames = selectedColor === color ? "color-picker-swatch color-picker-selected" : "color-picker-swatch"

                        return (i<10) ? <div
                            key={color}
                            style={this.swatchStyles(color)}
                            onClick={this.handleSelect(color)}
                            className={classNames}
                        >
                            {this.isSelected(color)}
                        </div>
                            : null
                    })}
                </div>
            </div>
        )
    }
}

class ColorPicker extends React.Component {
    constructor(props) {
        super(props)
        this.toggleCustom = this.toggleCustom.bind(this)

        this.state = {
            color: props.color,
            customMode: false,
        }
    }

    toggleCustom(e) {
        e.preventDefault()
        this.setState({customMode: !this.state.customMode})
    }

    render() {
        const { setColor, color } = this.props
        return (
            <div className="form-group" style={{marginBottom: '0'}}>
                <label>Color</label>
                <SwatchPicker color={color} setColor={setColor} />
            </div>
        )
    }
}

export default ColorPicker



// WEBPACK FOOTER //
// ./src/components/color_picker.jsx